var map = {
	"./citizenship.json": 92325,
	"./countries.json": 97617,
	"./farm/ownership_duration.json": 62555,
	"./farm/rating.json": 6732,
	"./farm/status.json": 94503,
	"./farm/type.json": 72495,
	"./investment.json": 35665,
	"./page/page.json": 11069,
	"./pagination.json": 17423,
	"./profile.json": 935,
	"./reserved_urls.json": 82504,
	"./transfer.json": 34355,
	"./usaStates.json": 62641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33499;